import '@/plugins/axios'
import { getBaseUrl, getParameter } from '@/utils/endpoint'

export function logout(params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.get(getBaseUrl() + '/customer/auth/logout', { params: new_params })
}

export function login(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/customer/auth/login', data, { params: new_params })
}

export function preRegister(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/customer/auth/pre-register', data, { params: new_params })
}

export function register(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/customer/auth/register', data, { params: new_params })
}

export function registerV2(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/customer/auth/registerv2', data, { params: new_params })
}

export function forgotPass(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/customer/auth/forgotpassword', data, { params: new_params })
}

export function validOtp(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/customer/auth/validotp', data, { params: new_params })
}

export function sendOtp(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/customer/auth/otp-resend', data, { params: new_params })
}

export function changePassAuth(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.put(getBaseUrl() + '/customer/auth/forgotpassword/changepassword', data, { params: new_params })
}

export function changeEmailAuth(id, data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/customer/auth/chengeemail/' + id, data, { params: new_params })
}

export function changePhoneAuth(id, data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/customer/auth/chengephone/' + id, data, { params: new_params })
}

export function verification(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/customer/auth/verification', data, { params: new_params })
}

export function checkPhone(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/customer/auth/v2/login', data, { params: new_params })
}

export function requestOTP(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/customer/auth/v2/otp/get', data, { params: new_params })
}

export function verifyOTPv2(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/customer/auth/v2/otp/verify', data, { params: new_params })
}

export function completeProfile(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.put(getBaseUrl() + '/customer/completeProfile', data, { params: new_params })
}
